Ext.define('SA.view.DataSheetWindow', {
    alias: 'widget.data-sheet-window',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-data-sheet-window',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    initComponent() {
        this.items = [
            {
                xtype: 'simple-container',

                items: [
                    {
                        xtype: 'component',
                        cls: 'sa-data-sheet-window-header',
                        html: Ext.util.Format.htmlEncode(this.title)
                    }, {
                        xtype: 'close-button'
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-data-sheet-window-body',

                items: [
                    {
                        xtype: 'image',
                        cls: 'sa-data-sheet-window-image',
                        id: 'imageCmp',
                        src: this.imageSrc
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-data-sheet-window-footer',

                items: [
                    {
                        xtype: 'sa-button',
                        id: 'closeBtn',
                        text: 'Close',
                        ui: 'primary',
                        width: 118
                    }
                ]
            }
        ];

        this.callParent();

        this.imageCmp = this.down('#imageCmp');
        this.closeBtn = this.down('#closeBtn');

        this.refreshSize();
    },

    initEvents() {
        this.callParent();

        this.mon(SA.Viewport, 'resize', this.refreshSize, this);

        this.imageCmp.on('load', this.setImageMaxWidth, this, {element: 'el'});
        this.closeBtn.on('click', this.onCloseClick, this);
    },

    onCloseClick() {
        this.destroy();
    },

    refreshSize() {
        var El = Ext.dom.Element,
            constrain = Ext.Number.constrain,
            width = constrain(El.getViewportWidth() - 50, 600, 1000),
            height = constrain(El.getViewportHeight() - 50, 350, 1000);

        this.setSize(width, height);
    },

    setImageMaxWidth() {
        var imageEl = this.imageCmp.el;

        imageEl.setWidth('auto');
        imageEl.setStyle('max-width', imageEl.getWidth() + 'px');
        imageEl.setWidth(null);
    }
});